import { API_ORIGIN } from '../api/client';

// 브라우저 탭 제목 + 파비콘만 런타임 갱신.
// apple-touch-icon / PWA manifest 는 백엔드 `/api/site-info/apple-touch-icon`,
// `/api/site-info/manifest.webmanifest` 동적 엔드포인트가 처리 (index.html 참조).
export function applySiteInfo({ browser_title, favicon_url } = {}) {
  if (browser_title) document.title = browser_title;
  if (favicon_url) {
    let link = document.querySelector('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = favicon_url;
  }
}

export async function loadAndApplySiteInfo() {
  try {
    const res = await fetch(`${API_ORIGIN}/api/site-info`);
    if (!res.ok) return;
    applySiteInfo(await res.json());
  } catch (e) {
    // 정적 폴백 (index.html 의 title/favicon) 유지
  }
}
